<ng-template #deleteLayer>
  <div>
    <div class="prompt-popover">
      <div class="prompt-title">Are you sure?</div>
      <button class="yes" (click)="popoverYes()">Yes</button><button class="no" (click)="popoverNo()">No</button>
    </div>
  </div>
</ng-template>
<div class="layer" [ngClass]="{'collapsed' : layer.collapsed}">
  <div class="row layer-title-row">
    <div class="col-md-3 layer-title-column">
      <div class="layer-title">
        <div class="grippy" dnd-sortable-handle *ngIf="!storyboard.read_only"><span></span></div>
        <div class="lock-layer-btn">
          <i class="fa fa-lock"
             [ngClass]="blockLayer ? 'red-lock' : 'grey-lock'"
             (click)="toggleBlockLayer(blockLayer)"
             *ngIf="!storyboard.read_only"></i>
        </div>
        <div class="title" (click)="toggleLayerTitle()" *ngIf="!showLayerTitleInput">{{ layer.title }}</div>
        <div class="title-input-wrapper" [hidden]="!showLayerTitleInput">
          <input type="text"
                 class="title-input"
                 #layerTitleInput
                 (blur)="toggleLayerTitle()"
                 (keypress)="handleInput($event)"
                 [(ngModel)]="layer.title">
        </div>
        <div class="collapse-btn" (click)="collapse(layer)"></div>
        <div class="actions">
          <i class="open-srt-editor" *ngIf="!storyboard.read_only && hasSRTOnLayer()" [ngbTooltip]="'Open SRT Editor'" [ngClass]="{'hide' : addNewClipMode}" (click)="openSRTEditor()"></i><i class="fa fa-plus-circle" *ngIf="!storyboard.read_only" [ngClass]="{'fa-plus-circle' : !addNewClipMode, 'fa-times-circle' : addNewClipMode}"
             (click)="swapNewClipMode()"></i><i class="fa fa-trash grey-trash-icon" *ngIf="!storyboard.read_only" [ngClass]="{'hide' : addNewClipMode}" [ngbPopover]="deleteLayer" #p="ngbPopover" placement="right"></i>
          <div class="new-clip-box" *ngIf="addNewClipMode">
            <i class="text-clip" (click)="openTextEditor()"></i>
            <i class="image-clip" (click)="openMediaLibrary()"></i>
            <i class="speech-indicator-clip" (click)="addSpeechIndicatorClip()"></i>
            <i class="audiogram-clip" (click)="openAudiogramEditor()"></i>
            <i class="transcribe-clip" (click)="openTranscribeEditor()"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-9 clip-column" [layers]="storyboard.timeline.layers" appTimelineDrag [clipsElementRef]="clipsElement">
      <div class="clips" #clips>
        <app-clip [clip]="clip" [layer]="layer" (duplicateClipEvent)="duplicateClip($event)" [readonly]="storyboard.read_only" (deleteClipEvent)="deleteClip($event)" (onUpdatePreview)="updatePreview($event)" class="clip-container" *ngFor="let clip of getClips(); let i = index"></app-clip>
      </div>
    </div>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/video-layer/video-layer.component.html